import { SVGProps } from 'react';

const CloudCog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m10.852 19.772-.383.924m.383-.924a3 3 0 0 0 2.296 0m-2.296 0a3 3 0 0 1-1.624-1.624m3.92-3.92.383-.923m-.383.923a3 3 0 0 1 1.624 1.624m-5.544 0a3 3 0 0 1 3.92-1.624m0 5.544a3 3 0 0 0 1.624-1.624m-1.624 1.624.382.924m1.242-2.548a3 3 0 0 0 0-2.296m0 2.296.923.383m-.923-2.68.923-.382m-4.843-1.241-.383-.923m-1.241 4.843a3 3 0 0 1 0-2.296m0 2.296-.923.383m.923-2.68-.923-.382M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2"
    />
  </svg>
);
export default CloudCog;
